<app-loader [ShowLoader]="globalService.showLoader"></app-loader>

<div class="cart-back-btn d-flex align-item pointer" (click)="goToPreferences()">
    <mat-icon>keyboard_arrow_left</mat-icon>
    <span class="cart-btn-heading" >{{ 'Selected Preference' | translate }}</span>
</div>

<div class="booking-method-wrapper">
    <div class="d-flex justify-center cart-flex">
        <div class="d-flex flex-column cart-flex-inner">
            <div class="booking-pay-methods">
                <h3 class="selected-cart-headings">{{ 'Selected Preference For' | translate }}!</h3>
                <div class="restaurant-name">
                    <span class="restaurant-name-heading">{{ selectedPeriodLabel }}</span>
                </div>
                <h3 class="selected-cart-headings">{{ 'Selected Items' | translate }}!</h3>
                <div class="selected-items-table-wrapper">
                    <div class="selected-items-table-row">
                        <div class="selected-items-table-cell">
                            <span class="selected-items-table-cell-heading">#</span>
                        </div>
                        <div class="selected-items-table-cell">
                            <span class="selected-items-table-cell-heading">Preferences</span>
                        </div>
                    </div>
                    <ng-container *ngIf="hasSelectedPreferences; else noSelectedPreferences">
                        <mat-expansion-panel *ngFor="let preference of selectedPreferenceViews; let preferenceIndex = index; trackBy: trackByPreferenceView">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span class="selected-item-count">{{ preferenceIndex + 1 }}</span>
                                    <span class="selected-item-title">{{ preference.title }}</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div class="table-container">
                                <table mat-table [dataSource]="preference.items">
                                    <ng-container matColumnDef="count">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element; let itemIndex = index">{{ itemIndex + 1 }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="item">
                                        <th mat-header-cell *matHeaderCellDef> {{'Items' | translate}} </th>
                                        <td mat-cell *matCellDef="let element">{{ element.value }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>{{'Action'|translate}}</th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-checkbox [checked]="element.checked" (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                                                (change)="onPreferenceItemToggle(preference, element, $event.checked)"></mat-checkbox>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                        </mat-expansion-panel>
                    </ng-container>

                    <ng-template #noSelectedPreferences>
                        <div class="p-3">{{ 'No Results Found' | translate }}</div>
                    </ng-template>
                    <h3 class="selected-cart-headings m-0">{{ 'Message' | translate }}!</h3>
                    <mat-form-field class="w-100 textarea-form-field" appearance="outline" [formGroup]="requestForm">
                                                <textarea matInput placeholder="Enter your message here..." rows="3" formControlName="message" maxlength="64"></textarea>
                                                <div *ngIf="requestForm.get('message')?.touched && requestForm.get('message')?.invalid" class="validation-error">
                                                    <span *ngIf="requestForm.get('message')?.errors?.['maxlength']">Message cannot exceed 64 characters.</span>
                                                </div>
                    </mat-form-field>
                    <!-- <textarea class="resize-textarea" matInput placeholder="Enter your message here..." type="text"></textarea> -->
                </div>
            </div>
        </div>
        <div class="restaurant-payment-option">
            <div class="guest-details">
                <h2 class="font-18 fw-700 nunito black">{{ 'Guest Details' | translate }}</h2>
                <span class="font-14 inter fw-400 black guest-text">{{ 'Please enter your information to proceed further
                    for
                    your ordering' | translate }}.</span>

                <div class="guest-info-cart" [formGroup]="mobileForm">
                    <div class="guest-name">
                        <label for="name" class="guest-details-label">{{ 'Enter name' | translate }}</label>
                                                <input type="text" placeholder="Enter here..." class="guest-detail-input" formControlName="fullName" maxlength="32" pattern="^[a-zA-Z ]+$"  [class.disabled-input]="mobileForm.get('fullName')?.disabled"/>
                                                <div *ngIf="mobileForm.get('fullName')?.touched && mobileForm.get('fullName')?.invalid" class="validation-error">
                                                    <span *ngIf="mobileForm.get('fullName')?.errors?.['required']">Name is required.</span>
                                                    <span *ngIf="mobileForm.get('fullName')?.errors?.['minlength']">Name must be at least 3 characters.</span>
                                                    <span *ngIf="mobileForm.get('fullName')?.errors?.['maxlength']">Name cannot exceed 32 characters.</span>
                                                    <span *ngIf="mobileForm.get('fullName')?.errors?.['pattern']">Name can contain only letters and spaces.</span>
                                                </div>
                    </div>

                    <div class="guest-name">
                        <label for="bookingRef" class="guest-details-label">{{ 'Booking ID (Optional)' | translate }}</label>
                        <input type="text" placeholder="Enter here..." class="guest-detail-input" formControlName="bookingRef" [class.disabled-input]="mobileForm.get('bookingRef')?.disabled"  />
                    </div>

                   

                    <div class="guest-mobile">
                        <label class="guest-details-label">{{ 'Enter mobile number' | translate}}</label>
                        <div class="country-code">
                            <mat-select formControlName="countryCode">
                                <mat-select-trigger>
                                    <span class="fi fi-{{ selectedCode }}"></span>
                                    {{ selectedDialCode }}
                                </mat-select-trigger>
                                <mat-option *ngFor="let countryCode of cc; let i = index"
                                    (click)="countryCodeSelected(i)"
                                    [value]="countryCode.dial_code">
                                    {{ countryCode.name }} ({{ countryCode.dial_code }})
                                </mat-option>
                            </mat-select>

                                                        <input type="number" placeholder="Enter Number" class="guest-detail-input"
                                                                formControlName="phoneNumber" (input)="numberValidation($event)"
                                                                (keydown)="onkeydown($event)" />

                        </div>
                        <div *ngIf="mobileForm.get('phoneNumber')?.touched && mobileForm.get('phoneNumber')?.invalid" class="validation-error">
                        <span *ngIf="mobileForm.get('phoneNumber')?.errors?.['required']">Phone number is required.</span>
                                                            <!-- Add more error messages here if you add more validators -->
                       </div>
                            <div class="errormsg-guest" *ngIf="
                  mobileForm.get('phoneNumber')?.errors?.min ||
                  mobileForm.get('phoneNumber')?.errors?.max
                ">
                {{ 'Invalid mobile number format' | translate }}.
              </div>                            

                    </div>
                    <button type="button" class="nunito pointer white otp-loader-btn" (click)="sendOtp()" [disabled]="isSubmitting || !mobileForm.valid" *ngIf="!isOtpSent">
                        <span class="btn-loader" *ngIf="isSubmitting" aria-hidden="true"></span>
                        <span>{{ isSubmitting ? ('Sending...' | translate) : ('Get OTP' | translate) }}</span>
                    </button>

                    
                </div>

                <div class="mobile-otp" *ngIf="isOtpSent && !isOtpVerified">
                    <h4>{{ 'Enter your OTP' | translate }}</h4>
                    <span class="otp-sent-text">{{ 'Your OTP has been sent to' | translate }}
                        <strong>{{ fullPhoneNumber }}</strong></span>

                    <div class="otp-fields" [formGroup]="otpForm">
                        <input type="number" class="otp" formControlName="otp1" #otp1 min="0" max="9"
                            data-idx="0" (keydown)="onOtpKeyDown($event)" (input)="onOtpInput($event)" #otpInput />
                        <input type="number" class="otp" formControlName="otp2" #otp2 min="0" max="9"
                            data-idx="1" (keydown)="onOtpKeyDown($event)" (input)="onOtpInput($event)" #otpInput />
                        <input type="number" class="otp" formControlName="otp3" #otp3 min="0" max="9"
                            data-idx="2" (keydown)="onOtpKeyDown($event)" (input)="onOtpInput($event)" #otpInput />
                        <input type="number" class="otp" formControlName="otp4" #otp4 min="0" max="9"
                            data-idx="3" (keydown)="onOtpKeyDown($event)" (input)="onOtpInput($event)" #otpInput />
                        <input type="number" class="otp" formControlName="otp5" #otp5 min="0" max="9"
                            data-idx="4" (keydown)="onOtpKeyDown($event)" (input)="onOtpInput($event)" #otpInput />
                        <input type="number" class="otp" formControlName="otp6" #otp6 min="0" max="9"
                            data-idx="5" (keydown)="onOtpKeyDown($event)" (input)="onOtpInput($event)" #otpInput />
                    </div>

                    <div class="timer-wrapper">
                        <div class="timer">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.99967 0.333008C3.33301 0.333008 0.333008 3.33301 0.333008 6.99967C0.333008 10.6663 3.33301 13.6663 6.99967 13.6663C10.6663 13.6663 13.6663 10.6663 13.6663 6.99967C13.6663 3.33301 10.6663 0.333008 6.99967 0.333008ZM6.99967 12.333C4.05967 12.333 1.66634 9.93967 1.66634 6.99967C1.66634 4.05967 4.05967 1.66634 6.99967 1.66634C9.93967 1.66634 12.333 4.05967 12.333 6.99967C12.333 9.93967 9.93967 12.333 6.99967 12.333ZM7.33301 3.66634H6.33301V7.66634L9.79967 9.79967L10.333 8.93301L7.33301 7.13301V3.66634Z"
                                    fill="black" />
                            </svg>

                            <span class="ml-5">{{ formatTime(timerValue) }}</span>
                        </div>

                        <span class="wrong-number pointer" (click)="wrongNumber()">{{ 'Wrong number' | translate }}?</span>
                    </div>
                    <div class="d-flex align-items-center otp-section">
                        <span class="resend-text">{{ 'Did not receive OTP' | translate }}? </span>
                        <span 
                            class="pointer resend-otp-btn ml-2"
                            (click)="resendOtp()"
                            [ngClass]="{ 'faded': timerValue > 0 }"
                            [style.pointerEvents]="timerValue > 0 ? 'none' : 'auto'"
                        >
                            {{ 'Resend OTP' | translate }}
                        </span>
                    </div>
                    <button type="button" class="nunito pointer white" (click)="verifyOtp()" [disabled]="isSubmitting">
                        {{ 'Submit' | translate }}
                    </button>

                </div>

                <div class="mobile-otp" *ngIf="isOtpSent && isOtpVerified">
                    <div class="guest-info-cart" [formGroup]="requestForm">
                    <div class="guest-room-no">
                        <label for="room-no" class="guest-details-label">{{ 'Room Number' | translate }}</label>
                                                <input type="text" placeholder="Enter here..." class="guest-detail-input" formControlName="roomNumber" maxlength="6" pattern="^[a-zA-Z0-9]{1,6}$" [class.disabled-input]="requestForm.get('roomNumber')?.disabled" />
                                                <div *ngIf="requestForm.get('roomNumber')?.touched && requestForm.get('roomNumber')?.invalid" class="validation-error">
                                                    <span *ngIf="requestForm.get('roomNumber')?.errors?.['required']">Room number is required.</span>
                                                    <span *ngIf="requestForm.get('roomNumber')?.errors?.['maxlength']">Room number cannot exceed 6 characters.</span>
                                                    <span *ngIf="requestForm.get('roomNumber')?.errors?.['pattern']">Room number can contain only letters and numbers.</span>
                                                </div>
                    </div>
                    </div>
                    <button type="button" class="nunito pointer white"
                        (click)="requestPreferences()" [disabled]="isSubmitting">
                        {{ 'Request now' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="visit-again">
        <p>{{ 'Thanks for visiting. We hope you like our services. For queries please' | translate }} -
            <a [href]="'mailto:' + ''" class="thankyou-text">{{ 'contact us' | translate }}</a>
        </p>
    </div>
</div>